import { Injectable } from "@angular/core";
import { TAny, TLoggerMsgType } from '../models/common.type';
import { AppConfiguration } from './app-config.service';

@Injectable({
    providedIn: 'root'
})
export class LoggerService {

    constructor(private appConfig: AppConfiguration) {}

    public print(type: TLoggerMsgType, ...data: TAny) {
        if (this.appConfig.data.isProd && ['warn', 'error'].indexOf(type) === -1) {
            return;
        }
        switch(type) {
            case 'info':
                console.info(...data);
                break;
            case 'warn':
                console.warn(...data);
                break;
            case 'error':
                console.error(...data);
                break;
            default:
                console.log(...data);
                break;
        }
    }
}